<template>
  <div class="content">
    <basic-panel v-if="generalBestPractice.fields.guides">
      <h3 slot="title" class="title is-4 is-marginless">Használati útmutató</h3>
      <div slot="content">
        <div v-for="guide in generalBestPractice.fields.guides"
             :key="guide.sys.id"
        >
          <a :href="guide.fields.file.url">
            <div class="file has-name is-fullwidth">
              <label class="file-label">
                <span class="file-cta">
                  <span class="file-icon"><font-awesome-icon icon="download"></font-awesome-icon></span>
                  <span class="file-label">Megtekintés</span>
                </span>
                <span class="file-name">{{ guide.fields.title }}</span>
              </label>
            </div>
          </a>
        </div>
      </div>
    </basic-panel>

    <basic-panel v-if="generalBestPractice.fields.descriptionFiles">
      <h3 slot="title" class="title is-4 is-marginless">Szöveges leírás</h3>
      <div slot="content">
        <div v-for="descriptionFile in generalBestPractice.fields.descriptionFiles"
             :key="descriptionFile.sys.id"
        >
          <a :href="descriptionFile.fields.file.url">
            <div class="file has-name is-fullwidth">
              <label class="file-label">
                <span class="file-cta">
                  <span class="file-icon"><font-awesome-icon icon="download"></font-awesome-icon></span>
                  <span class="file-label">Megtekintés</span>
                </span>
                <span class="file-name">{{ descriptionFile.fields.title }}</span>
              </label>
            </div>
          </a>
        </div>
      </div>
    </basic-panel>

    <basic-panel v-if="generalBestPractice.fields.flowcharts">
      <h3 slot="title" class="title is-4 is-marginless">Folyamatábra</h3>
      <div slot="content">
        <div v-for="flowchart in generalBestPractice.fields.flowcharts"
             :key="flowchart.sys.id"
        >
          <a :href="flowchart.fields.file.url">
            <div class="file has-name is-fullwidth">
              <label class="file-label">
                <span class="file-cta">
                  <span class="file-icon"><font-awesome-icon icon="download"></font-awesome-icon></span>
                  <span class="file-label">Megtekintés</span>
                </span>
                <span class="file-name">{{ flowchart.fields.title }}</span>
              </label>
            </div>
          </a>
        </div>
      </div>
    </basic-panel>

    <basic-panel v-if="generalBestPractice.fields.processTables">
      <h3 slot="title" class="title is-4 is-marginless">Folyamattábla</h3>
      <div slot="content">
        <div v-for="processTable in generalBestPractice.fields.processTables"
             :key="processTable.sys.id"
        >
          <a :href="processTable.fields.file.url">
            <div class="file has-name is-fullwidth">
              <label class="file-label">
                <span class="file-cta">
                  <span class="file-icon"><font-awesome-icon icon="download"></font-awesome-icon></span>
                  <span class="file-label">Megtekintés</span>
                </span>
                <span class="file-name">{{ processTable.fields.title }}</span>
              </label>
            </div>
          </a>
        </div>
      </div>
    </basic-panel>

    <basic-panel v-if="generalBestPractice.fields.errorModeTables">
      <h3 slot="title" class="title is-4 is-marginless">Hibamód tábla</h3>
      <div slot="content">
        <div v-for="errorModeTable in generalBestPractice.fields.errorModeTables"
             :key="errorModeTable.sys.id"
        >
          <a :href="errorModeTable.fields.file.url">
            <div class="file has-name is-fullwidth">
              <label class="file-label">
                <span class="file-cta">
                  <span class="file-icon"><font-awesome-icon icon="download"></font-awesome-icon></span>
                  <span class="file-label">Megtekintés</span>
                </span>
                <span class="file-name">{{ errorModeTable.fields.title }}</span>
              </label>
            </div>
          </a>
        </div>
      </div>
    </basic-panel>

    <basic-panel v-if="generalBestPractice.fields.methodologies">
      <h3 slot="title" class="title is-4 is-marginless">Módszertan</h3>
      <div slot="content">
        <div v-for="methodology in generalBestPractice.fields.methodologies"
             :key="methodology.sys.id"
        >
          <a :href="methodology.fields.file.url" target="_blank">
            <div class="file has-name is-fullwidth">
              <label class="file-label">
                <span class="file-cta">
                  <span class="file-icon"><font-awesome-icon icon="download"></font-awesome-icon></span>
                  <span class="file-label">Letöltés</span>
                </span>
                <span class="file-name">{{ methodology.fields.title }}</span>
              </label>
            </div>
          </a>
        </div>
      </div>
    </basic-panel>

    <basic-panel v-if="generalBestPractice.fields.presentations">
      <h3 slot="title" class="title is-4 is-marginless">Prezentációk</h3>
      <div slot="content">
        <div v-for="presentation in generalBestPractice.fields.presentations"
             :key="presentation.sys.id"
        >
          <a :href="presentation.fields.file.url">
            <div class="file has-name is-fullwidth">
              <label class="file-label">
                <span class="file-cta">
                  <span class="file-icon"><font-awesome-icon icon="download"></font-awesome-icon></span>
                  <span class="file-label">Megtekintés</span>
                </span>
                <span class="file-name">{{ presentation.fields.title }}</span>
              </label>
            </div>
          </a>
        </div>
      </div>
    </basic-panel>

    <basic-panel v-if="generalBestPractice.fields.systemComponents">
      <h3 slot="title" class="title is-4 is-marginless">Rendszerelemek</h3>
      <div slot="content">
        <div v-for="systemComponent in generalBestPractice.fields.systemComponents"
             :key="systemComponent.sys.id"
        >
          <a :href="systemComponent.fields.file.url">
            <div class="file has-name is-fullwidth">
              <label class="file-label">
                <span class="file-cta">
                  <span class="file-icon"><font-awesome-icon icon="download"></font-awesome-icon></span>
                  <span class="file-label">Megtekintés</span>
                </span>
                <span class="file-name">{{ systemComponent.fields.title }}</span>
              </label>
            </div>
          </a>
        </div>
      </div>
    </basic-panel>

    <basic-panel v-if="generalBestPractice.fields.systemTables">
      <h3 slot="title" class="title is-4 is-marginless">Rendszertáblák</h3>
      <div slot="content">
        <div v-for="systemTable in generalBestPractice.fields.systemTables"
             :key="systemTable.sys.id"
        >
          <a :href="systemTable.fields.file.url">
            <div class="file has-name is-fullwidth">
              <label class="file-label">
                <span class="file-cta">
                  <span class="file-icon"><font-awesome-icon icon="download"></font-awesome-icon></span>
                  <span class="file-label">Megtekintés</span>
                </span>
                <span class="file-name">{{ systemTable.fields.title }}</span>
              </label>
            </div>
          </a>
        </div>
      </div>
    </basic-panel>

    <basic-panel v-if="generalBestPractice.fields.other">
      <h3 slot="title" class="title is-4 is-marginless">Egyéb</h3>
      <div slot="content">
        <div v-for="otherFile in generalBestPractice.fields.other"
             :key="otherFile.sys.id"
        >
          <a :href="otherFile.fields.file.url">
            <div class="file has-name is-fullwidth">
              <label class="file-label">
                <span class="file-cta">
                  <span class="file-icon"><font-awesome-icon icon="download"></font-awesome-icon></span>
                  <span class="file-label">Megtekintés</span>
                </span>
                <span class="file-name">{{ otherFile.fields.title }}</span>
              </label>
            </div>
          </a>
        </div>
      </div>
    </basic-panel>
  </div>
</template>

<script>
  import BasicPanel from '@/components/General/BasicPanel'

  export default {
    props: [
      'generalBestPractice'
    ],
    components: {
      BasicPanel
    }
  }
</script>

<style scoped>
  .file {
    margin-bottom: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/BestPractice/GeneralBestPracticeDetailed.vue